export default __webpack_public_path__ + "static/media/blackjack.8423b678.png";